module.exports = "<div class=\"container theme-showcase\" role=\"main\">\n    <div class=\"col-md-12\">\n        <app-page-contents [pageName]=\"'downloads_catalogues'\"></app-page-contents>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/pages/page-downloads-catalogues/page-downloads-catalogues.component.html
// module id = ./src/app/components/pages/page-downloads-catalogues/page-downloads-catalogues.component.html
// module chunks = main